export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC_1z8WV5mxr-WfR3JM692lmjnKtobxtYY',
    authDomain: 'findmehireme.firebaseapp.com',
    databaseURL: 'https://findmehireme.firebaseio.com/',
    projectId: 'findmehireme',
    storageBucket: 'gs://findmehireme.appspot.com/',
    messagingSenderId: '<your-messaging-sender-id>'
  }
};


// WEBPACK FOOTER //
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/environments/environment.ts